import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SimflexityPayTerms } from "web-apps/company/pages/payments/simflexityPay/simflexityPayTerms";
import { TermsWebLink } from "./termsWebLink.component";
import {
  SubscriptionCardTitle,
  TermsLinks,
} from "./companySubscription.styled";

export const SubscriptionTerms: React.FC = () => {
  const { t } = useTranslation();

  const [showTerms, setShowTerms] = useState(false);

  return (
    <>
      <SubscriptionCardTitle>
        {t("ProfileCompany.TermsAndConditions")}
      </SubscriptionCardTitle>

      <TermsLinks>
        <TermsWebLink
          selectedTerms={t("General.TermsAndConditionsLink")}
          linkName={t("ProfileCompany.GeneralTerms")}
          link={"https://simflexity.com/allmanna-villkor"}
        />

        <TermsWebLink
          selectedTerms={t("General.PersonalIntegrityLink")}
          linkName={t("ProfileCompany.PrivacyPolicy")}
          link={"https://simflexity.com/integritetspolicy"}
        />

        <TermsWebLink
          selectedTerms={t("ProfileCompany.TermsSimflexityPay")}
          linkName={t("ProfileCompany.TermsSimflexityPay")}
          onClick={() => setShowTerms(true)}
        />
      </TermsLinks>

      <SimflexityPayTerms setShowTerms={setShowTerms} showTerms={showTerms} />
    </>
  );
};
